var _circle, _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApprovedConf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62_2947",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00B55E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_62_2947)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 16.5C26 10.9771 21.5228 6.5 16 6.5C10.4771 6.5 6 10.9771 6 16.5C6 22.0228 10.4771 26.5 16 26.5C21.5228 26.5 26 22.0228 26 16.5Z",
    fill: "#85E1B5",
    fillOpacity: 0.68
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2906 9.21324C17.5674 8.9861 16.7978 8.86365 15.9996 8.86365C11.7822 8.86365 8.36328 12.2826 8.36328 16.5C8.36328 20.7174 11.7822 24.1364 15.9996 24.1364C20.2171 24.1364 23.636 20.7174 23.636 16.5C23.636 15.7019 23.5135 14.9323 23.2864 14.2091",
    stroke: "#00B55E",
    strokeWidth: 1.74545,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14L16 17.5L25.0002 7.5",
    stroke: "#00B55E",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedConf);
export default __webpack_public_path__ + "static/media/approvedConf.181445a6c153fcec09dda64e52cd9481.svg";
export { ForwardRef as ReactComponent };